import { Behavior } from './Behavior';
import { ContentType, LessonMode, PartialScoringType, QuestionFeedbackState } from '../../Constants';
import numberLineService from '../services/NumberLineService';
import UtilsService from '../services/UtilsService';
import questionFeedbackManager from '../managers/QuestionFeedbackManager';

export class NumberLineBehavior extends Behavior {
  checkForValidResponse = (responseAnswer) => {
    if (!responseAnswer || !responseAnswer.answers || responseAnswer.answers.length === 0) {
      return false;
    }
    return true;
  }

  isAutoScored = (model) => {
    const autoScore = ContentType.getAutoscore(model.type) && !model.survey && !model.unscored;
    return autoScore;
  }

  setResponseData = (data, responseAnswer, model) => {
    responseAnswer = data;
  }

  getInitializedResponse = (lessonElementId) => {
    const responseAnswer = { answers: [] };
    return responseAnswer;
  }

  getCorrectAnswersText = (model) => {
    return null;
  }

  setCorrectAnswer = (state, model) => {
    // Do nothing. This is handled directly in the NumberLine component. Changing the user's responses is not the correct way to handle this.
    // state.currentResponseAnswer.answers = model.validation.correctAnswers;
  }

  resetStudentAnswer = (state) => {
    // state.currentResponseAnswer = UtilsService.safeMobxClone(state.cachedResponseAnswer);
  }

  getQuestionFeedbackText = (model, correctFeedback, incorrectFeedback, correctFeedbackBody, incorrectFeedbackBody, mode, questionIsCorrect, currentAttemptCount, { lessonElementState }) => {
    let textBody = '';
    if (mode === LessonMode.PREVIEW || mode === LessonMode.ITEM_PREVIEW || mode === LessonMode.STUDENT_PREVIEW || mode === LessonMode.PUBLISHER_PREVIEW) {
      textBody += UtilsService.previewWarning();
    } else {
      if (typeof currentAttemptCount !== 'undefined' && currentAttemptCount !== -1 && currentAttemptCount > 1) {
        textBody += UtilsService.saveWarning();
      } else {
        textBody += UtilsService.saveCommit();
      }
    }

    let textHeader = '';
    let attemptsText = '';
    
    // Add attempts remaining text for practice mode when answer is incorrect or partially correct
    if (questionFeedbackManager.isPractice && 
        (questionIsCorrect === QuestionFeedbackState.INCORRECT || questionIsCorrect === QuestionFeedbackState.PARTIAL_CORRECT) &&
        model.lessonElementId) {
      attemptsText = questionFeedbackManager.getAttemptsRemainingText(model.lessonElementId);
    }

    if (questionIsCorrect === QuestionFeedbackState.CORRECT) {
      textHeader = correctFeedback;
      if (correctFeedbackBody) {
        textBody = `${correctFeedbackBody} ${textBody}`;
      }
    } else if (questionIsCorrect === QuestionFeedbackState.PARTIAL_CORRECT) {
      textHeader = `${UtilsService.partiallyCorrect()}`;
      let custom = '';
      if (incorrectFeedbackBody) {
        custom = `${incorrectFeedbackBody } `;
      }

      textBody = `${UtilsService.partiallyCorrectPrompt()}. <br/>${ custom }${textBody}`;
    } else {
      textHeader = incorrectFeedback;
      if (incorrectFeedbackBody) {
        textBody = `${incorrectFeedbackBody} ${textBody}`;
      }
    }

    // Add attempts text after the header if it exists
    if (attemptsText) {
      textHeader += attemptsText;
    }

    let finalText = '<div class=\'question-feedback-header\'>';
    finalText += textHeader;
    finalText += '</div>';
    finalText += '<div class=\'question-feedback-body\'>';
    finalText += textBody;
    finalText += '</div>';

    return finalText;
  }

  isAnswerCorrect = (answerId, lessonElementState, model) => {
    if (lessonElementState.correctAnswerShowing) {
      return true;
    }

    return lessonElementState.isScored && (lessonElementState.submittedItemScore === lessonElementState.maxScore);
  }

  isQuestionCorrect = (lessonElementState) => {
    if (!lessonElementState) {
      return QuestionFeedbackState.INCORRECT;
    }

    if (lessonElementState.submittedItemScore >= lessonElementState.maxScore) {
      return QuestionFeedbackState.CORRECT;
    }

    if ((lessonElementState.submittedItemScore > 0) && (lessonElementState.submittedItemScore < lessonElementState.maxScore)) {
      return QuestionFeedbackState.PARTIAL_CORRECT;
    }

    return QuestionFeedbackState.INCORRECT;
  }
}

export default new NumberLineBehavior();
